

        <!-- wrapper-size 固定寬-->
        <nav id="nav_mega_menu" class="nav_mega_menu">
            <!-- class="nav_mega_menu" ib專用-->
            <ul class="navigation fir_nav">
                <!-- class="mb_navigation" mb專用-->
                <li *ngFor="let menu of menuList.children; let menuIndex= index;" [id]="'menuIndex_'+menuIndex" [class]="currentMenuId==menu.menuIxd?'cbp-hropen':''">
                    <!-- Level 1 Menu -->
                    <span>{{menu.menuName}}</span>
                    <div [ngClass]="{'cbp-hrsub':true,
                    'inner_1row': menu.children.length===1,
                    'inner_2row': menu.children.length===2,
                    'inner_3row': menu.children.length===3 }">
                        <div class="idx_tb">
                            <!-- 第二排 -->
                            <ul class="sec_nav">
                                <ng-container *ngFor="let submenu of menu.children; let j = index;">
                                    <li *ngIf="j%4==0">
                                        <!-- Level 2 Menu 下拉後的Menu -->
                                        <span [attr.name]="submenu.taskIxd" (click)="toggleSubMainMenu($event,submenu)" [class]="submenu.children.length > 0?'lv2_tit':''">
                                            {{submenu.menuName}}
                                        </span>

                                        <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'" *ngIf="submenu.children.length > 0">
                                            <li *ngFor="let submenu2 of submenu.children">
                                                <ng-container *ngIf='submenu2.children.length === 0'>
                                                    <span [attr.name]="submenu2.taskIxd" (click)="toggleSubMainMenu($event,submenu2)" target="_self">
                                                        {{submenu2.menuName}}
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf='submenu2.children.length>0'>
                                                    <li>
                                                        <div class="lv4_tit">{{submenu2.menuName}}</div>
                                                        <div class="lv4_menu">
                                                            <ul>
                                                                <li *ngFor="let submenu3 of submenu2.children">
                                                                    <span [attr.name]="submenu3.taskIxd" (click)="toggleSubMainMenu($event,submenu3)" target="_self">
                                                                        {{submenu3.menuName}}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>

                            <!-- 第二排 -->
                            <ul class="sec_nav" *ngIf="menu.children.length>=2">
                                <ng-container *ngFor="let submenu of menu.children; let j = index;">
                                    <li *ngIf="j%4==1">
                                        <!-- Level 2 Menu 下拉後的Menu -->
                                        <span [attr.name]="submenu.taskIxd" (click)="toggleSubMainMenu($event,submenu)" [class]="submenu.children.length > 0?'lv2_tit':''">
                                            {{submenu.menuName}}
                                        </span>

                                        <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'" *ngIf="submenu.children.length > 0">
                                            <li *ngFor="let submenu2 of submenu.children">
                                                <ng-container *ngIf='submenu2.children.length === 0'>
                                                    <span *ngIf="submenu2.menuName!='企業貸款線上申請'; else elseContent" [attr.name]="submenu2.taskIxd" (click)="toggleSubMainMenu($event,submenu2)" target="_self">
                                                        {{submenu2.menuName}}
                                                    </span>
                                                    <ng-template #elseContent>
                                                        <span [attr.name]="submenu2.taskIxd" (click)="toggleSubMainMenu($event,submenu2)" target="_self">
                                                            {{submenu2.menuName}}<span class="loan_icon"></span>
                                                        </span>
                                                    </ng-template>
                                                </ng-container>
                                                <ng-container *ngIf='submenu2.children.length>0'>
                                                    <li>
                                                        <div class="lv4_tit">{{submenu2.menuName}}</div>
                                                        <div class="lv4_menu">
                                                            <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'">
                                                                <li *ngFor="let submenu3 of submenu2.children">
                                                                    <span [attr.name]="submenu3.taskIxd" (click)="toggleSubMainMenu($event,submenu3)" target="_self">
                                                                        {{submenu3.menuName}}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>
                            <!-- 第三排 -->
                            <ul class="sec_nav" *ngIf="menu.children.length>=3">
                                <ng-container *ngFor="let submenu of menu.children; let j = index;">
                                    <li *ngIf="j%4==2">
                                        <!-- Level 2 Menu 下拉後的Menu -->
                                        <span [attr.name]="submenu.taskIxd" (click)="toggleSubMainMenu($event,submenu)" [class]="submenu.children.length > 0?'lv2_tit':''">
                                            {{submenu.menuName}}
                                        </span>

                                        <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'" *ngIf="submenu.children.length > 0">
                                            <li *ngFor="let submenu2 of submenu.children">
                                                <ng-container *ngIf='submenu2.children.length === 0'>
                                                    <span [attr.name]="submenu2.taskIxd" (click)="toggleSubMainMenu($event,submenu2)" target="_self">
                                                        {{submenu2.menuName}}
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf='submenu2.children.length>0'>
                                                    <li>
                                                        <div class="lv4_tit">{{submenu2.menuName}}</div>
                                                        <div class="lv4_menu">
                                                            <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'">
                                                                <li *ngFor="let submenu3 of submenu2.children">
                                                                    <span [attr.name]="submenu3.taskIxd" (click)="toggleSubMainMenu($event,submenu3)" target="_self">
                                                                        {{submenu3.menuName}}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>
                            <!-- 第四排 -->
                            <ul class="sec_nav" *ngIf="menu.children.length>=4">
                                <ng-container *ngFor="let submenu of menu.children; let j = index;">
                                    <li *ngIf="j%4==3">
                                        <!-- Level 2 Menu 下拉後的Menu -->
                                        <span [attr.name]="submenu.taskIxd" (click)="toggleSubMainMenu($event,submenu)" [class]="submenu.children.length > 0?'lv2_tit':''">
                                            {{submenu.menuName}}
                                        </span>
                                        <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'" *ngIf="submenu.children.length > 0">
                                            <li *ngFor="let submenu2 of submenu.children">
                                                <ng-container *ngIf='submenu2.children.length === 0'>
                                                    <span [attr.name]="submenu2.taskIxd" (click)="toggleSubMainMenu($event,submenu2)" target="_self">
                                                        {{submenu2.menuName}}
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf='submenu2.children.length>0'>
                                                    <li>
                                                        <div class="lv4_tit">{{submenu2.menuName}}</div>
                                                        <div class="lv4_menu">
                                                            <ul [class]="submenu.styleClass=='tre_nav'?'tre_nav on':'tre_nav'">
                                                                <li *ngFor="let submenu3 of submenu2.children">
                                                                    <span [attr.name]="submenu3.taskIxd" (click)="toggleSubMainMenu($event,submenu3)" target="_self">
                                                                        {{submenu3.menuName}}
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>

                        </div>
                    </div>
                </li>

            </ul>
        </nav>
 